import fetchApi from 'services/api/connector';

/**
 * Fetches the commands (tool runs) that created or updated a vulnerability, newest first.
 *
 * @param {string} workspaceName - Workspace the vulnerability belongs to.
 * @param {number} vulnId - Vulnerability id.
 * @returns {Promise<{tools: Array<{command: string, command_id: number, create_date: string}>}>} Raw backend payload.
 */
const fetchVulnToolsHistory = (workspaceName, vulnId) => fetchApi(`ws/${workspaceName}/vulns/${vulnId}/tools_history`);

export default fetchVulnToolsHistory;
